import { render, staticRenderFns } from "./AddDocsDialog.vue?vue&type=template&id=0efc6bc0"
import script from "./AddDocsDialog.vue?vue&type=script&lang=js"
export * from "./AddDocsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports